// extracted by mini-css-extract-plugin
export default {"tab":"CategoryTab_tab__AY719","selected":"CategoryTab_selected__ybQEt","unselected":"CategoryTab_unselected__WutmA"};